import { render } from "./CDISettings.vue?vue&type=template&id=985d074e&scoped=true"
import script from "./CDISettings.vue?vue&type=script&lang=js"
export * from "./CDISettings.vue?vue&type=script&lang=js"

import "./CDISettings.vue?vue&type=style&index=0&id=985d074e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985d074e"]])

export default __exports__